export default __webpack_public_path__ + "static/media/linkedin-dark.24852c0f.svg";